export const UNDEFINED = "undefined";
export const DCV_STRATEGY = "DCVStrategy";
export const AUDIO = "audio";
export const ANSWER = "answer";
export const CHROME = "chrome";
